import React, { useCallback, useEffect, useState } from 'react';
import axios from '../config';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';

import { Box, Button, Checkbox, FormControlLabel, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

const yes = (value) => value ? 'да' : 'нет'

const updatedLabel = (value) => {
    if (value === null || value === undefined) {
        return '—'
    }
    return String(value)
}

const Monitor = () => {
    const [data, setData] = useState(null)
    const [error, setError] = useState('')
    const [auto, setAuto] = useState(true)

    const load = useCallback(async () => {
        try {
            const response = await axios.get('umonitor', { headers: { token: Cookies.get('token') } })
            setData(response.data)
            setError('')
        } catch (err) {
            setError('Мониторинг сейчас недоступен')
        }
    }, [])

    useEffect(() => {
        load()
    }, [load])

    useEffect(() => {
        if (!auto) {
            return
        }
        const timer = setInterval(load, 15000)
        return () => clearInterval(timer)
    }, [auto, load])

    const last = data && data.last_run
    const finished = last && last.finished_at ? dayjs(last.finished_at).format('DD/MM/YYYY HH:mm:ss') : 'ещё не было'

    return (
        <Paper sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">Мониторинг</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                        sx={{ ml: 0, mr: 1 }}
                        control={
                            <Checkbox
                                size="small"
                                checked={auto}
                                onChange={(event) => setAuto(event.target.checked)}
                                sx={{ p: '4px' }}
                            />
                        }
                        label={<Typography sx={{ fontSize: 13, ml: '2px' }}>Автообновление</Typography>}
                    />
                    <Button size="small" onClick={load}>Обновить</Button>
                </Box>
            </Box>
            {error ? <Typography sx={{ color: '#7f7f7f', mb: 2 }}>{error}</Typography> : null}
            {data ? (
                <>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 1, mb: 2 }}>
                        <Status label="База" value={data.mongo ? 'доступна' : 'нет ответа'} />
                        <Status label="Задачи" value={data.jobs_enabled ? `включены, каждые ${Math.round(data.interval_seconds / 60)} мин` : 'выключены'} />
                        <Status label="Последний проход" value={finished} />
                        <Status label="eBay за проход" value={last ? String(last.ebay) : '—'} />
                        <Status label="Чтение почты" value={yes(data.imap)} />
                        <Status label="Отправка почты" value={yes(data.smtp)} />
                        <Status label="Tilda EN" value={yes(data.tilda_en)} />
                        <Status label="Tilda RU" value={yes(data.tilda_ru)} />
                    </Box>
                    <Typography sx={{ mb: 1, fontSize: 14 }}>Перевозчики и открытые отправки</Typography>
                    <Table size="small" sx={{ mb: 2 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Служба</TableCell>
                                <TableCell>Опрос</TableCell>
                                <TableCell align="right">Обновлено</TableCell>
                                <TableCell align="right">Открытые</TableCell>
                                <TableCell align="right">С треком</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(data.carriers || []).map((row) => (
                                <TableRow key={row.code}>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.connected ? 'подключён' : 'не подключён'}</TableCell>
                                    <TableCell align="right">{updatedLabel(row.updated)}</TableCell>
                                    <TableCell align="right">{row.open}</TableCell>
                                    <TableCell align="right">{row.with_tracking}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Typography sx={{ mb: 1, fontSize: 14 }}>Ошибки с последнего прохода</Typography>
                    <ErrorList
                        events={data.errors && data.errors.current}
                        empty="С последнего прохода ошибок нет"
                    />
                </>
            ) : null}
        </Paper>
    )
}

const ErrorList = ({ events, empty }) => (
    <Box
        component="pre"
        sx={{
            m: 0,
            p: 1.5,
            maxHeight: 240,
            overflow: 'auto',
            bgcolor: '#1e1e1e',
            color: '#d6d6d6',
            fontSize: 12,
            lineHeight: 1.45,
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
        }}
    >
        {events && events.length
            ? events.map((event) => `${event.at}  ${event.summary}${event.detail ? `\n${event.detail}` : ''}`).join('\n\n')
            : empty}
    </Box>
)

const Status = ({ label, value }) => (
    <Box sx={{ bgcolor: '#fff', border: '1px solid #ececec', borderRadius: 1, p: 1 }}>
        <Typography sx={{ fontSize: 11, color: '#7f7f7f' }}>{label}</Typography>
        <Typography sx={{ fontSize: 14 }}>{value}</Typography>
    </Box>
)

export default Monitor
